import React from 'react';

import RootWrapper from '../../../RootWrapper';
import TooltipsPlayerWrapper from '../../tooltip/TooltipsPlayerWrapper';
import IframeWrapper from './mods/iframe/MainWrapper';
import AccessWrapper from './content/AccessWrapper';

// Module Available for the project
function CustomWrapper() {
  return (
    <>
      <RootWrapper />
      <TooltipsPlayerWrapper />
      <AccessWrapper />
      <IframeWrapper />
    </>
  )
}

export default CustomWrapper;
